import React from 'react';

const AboutSection: React.FC = () => {

  return (
    <section id="about" className="py-24 relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-[url('https://images.pexels.com/photos/1540406/pexels-photo-1540406.jpeg')] bg-cover bg-center opacity-30"></div>
        <div className="absolute inset-0 bg-black bg-opacity-90"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl font-bold text-white mb-6">About DJ Landan Time</h2>

          <div className="bg-black/30 p-6 rounded-lg mb-8">
            <div className="prose prose-invert text-gray-400 leading-relaxed">
              <p className="mb-4">
                DJ Landan Time is an independent UK-based music producer, song writer, DJ, and remixer whose career is rooted in decades of experience behind the decks and a deep passion for dance music culture. Known for his versatility, he produces across all styles of house music — from deep and soulful to tech, big room, and festival-driven sounds — while also drawing on hip-hop, pop, and cinematic influences.
              </p>

              <p className="mb-4">
                With years spent refining his craft in both clubs and studios, his sound blends uplifting dance energy, Balearic warmth, funk textures, and soulful, piano-driven grooves into a distinctive, contemporary style. His productions balance classic influences with modern polish, making them equally effective on dancefloors, radio, and digital platforms.
              </p>

              <p className="mb-4">
                Working independently, DJ Landan Time oversees every stage of his releases, from songwriting and sound design to mixing, mastering, and promotion. This hands-on approach has helped his catalogue achieve consistent national and international traction across charts, radio, and DJ networks, while maintaining a strong creative identity.
              </p>

              <p className="mb-4">
                Recent success includes strong global support for Tell Me (ClubSoul Remix), which has received widespread radio and DJ backing, reached No. 8 on the MusicWorx Download Charts, and continues to gain momentum worldwide. His wider chart history includes a #1 collaborative album on iTunes, multiple Top 50 and Top 100 placements, Top 10 rankings on Traxsource, and features on the Beatport Hype Chart.
              </p>

              <p className="mb-4">
                A multi-genre producer at heart, DJ Landan Time thrives on switching up styles and flavours in the studio, driven by a genuine love for making music and exploring new creative directions. This flexibility allows him to consistently deliver fresh, engaging material while staying rooted in authentic club culture.
              </p>

              <p className="mb-6">
                A seasoned collaborator and independent powerhouse, he continues to push boundaries in the electronic space, blending underground credibility with main-room impact. With multiple releases lined up, 2026 is shaping up to be a defining year as he strengthens his focus on high-energy, club and festival-ready house music.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;